import { isly } from "isly";
import { system } from "../system";
export var Numeric;
(function (Numeric) {
    var _a;
    _a = isly
        .object({ years: isly.number().optional(), months: isly.number().optional(), days: isly.number().optional() }, "isoly.Date.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function parse(value) {
        const [year, month, day] = value
            ?.split("-", 3)
            .map(v => Number.parseInt(v))
            .map(v => (Number.isSafeInteger(v) ? v : undefined)) ?? [];
        return {
            ...(year ? { years: year } : {}),
            ...(month ? { months: month - 1 } : {}),
            ...(day ? { days: day - 1 } : {}),
        };
    }
    Numeric.parse = parse;
    function format(value) {
        return new system.Date(system.Date.UTC(value.years ?? 0, value.months ?? 0, (value.days ?? 0) + 1, 12))
            .toISOString()
            .substring(0, 10);
    }
    Numeric.format = format;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map